<template>
<div class="chapter">
<div class="inner_page">
<p class="copy1"><a id="page_4"></a><span class="bold"><span class="family">Title page illustration:</span></span> <span class="smallcap">HM</span> <em class="italic">Castle</em>-class Admiralty standard trawler, general arrangement, 1917.</p>
<p class="copy0">Copyright © Steve R Dunn 2021</p>
<p class="copy2">First published in Great Britain in 2021 by</p>
<p class="copy2">Seaforth Publishing,</p>
<p class="copy2">A division of Pen &amp; Sword Books Ltd,</p>
<p class="copy2">47 Church Street,</p>
<p class="copy2">Barnsley S70 2AS</p>
<p class="copy01"><span class="weblink"><a href="http://www.seaforthpublishing.com" target="_blank"><span class="underline">www.seaforthpublishing.com</span></a></span></p>
<p class="copy2"><em class="italic">British Library Cataloguing in Publication Data</em></p>
<p class="copy2">A catalogue record for this book is available from the British Library</p>
<p class="copy1a">ISBN 978 1 5267 9486 4 (HARDBACK)</p>
<p class="copy2">ISBN 978 1 5267 9487 1 (EPUB)</p>
<p class="copy2">ISBN 978 1 5267 9488 8 (KINDLE)</p>
<p class="copy1a">All uncredited photographs are from the John Lambert collection</p>
<p class="copy1a">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or any information storage and retrieval system, without prior permission in writing of both the copyright owner and the above publisher.</p>
<p class="copy1a">The right of Steve R Dunn to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy1a">Pen &amp; Sword Books Limited incorporates the imprints of Atlas,</p>
<p class="copy2">Archaeology, Aviation, Discovery, Family History, Fiction, History, Maritime, Military, Military Classics, Politics, Select, Transport, True Crime, Air World, Frontline Publishing, Leo Cooper, Remember When, Seaforth Publishing, The Praetorian Press, Wharncliffe Local History, Wharncliffe Transport, Wharncliffe True Crime and White Owl</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?0919a7d9